import Comment from '@spraypaint/Comment';
import dayjs from 'dayjs';
import { useValidation } from '@/app/form/ValidationForm';
import { Controller, useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { TextInput } from '../inputs';
import { ButtonPrimary } from '../buttons';

export type CommentFormValue = {
  content: string;
};

type Props = {
  comments?: Array<Comment>;
  isLoading: boolean;
  isSuccess: boolean;
  onSubmit: (data: CommentFormValue) => void;
};

export const CommentList = ({
  comments,
  onSubmit,
  isLoading,
  isSuccess,
}: Props) => {
  const {
    handleSubmit,
    formState: { errors },
    setValue,
    register,
  } = useForm<CommentFormValue>();

  useEffect(() => {
    if (isSuccess) setValue('content', '');
  }, [isSuccess]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-row justify-between mb-8">
        <TextInput
          textarea
          placeholder="Ajouter un commentaire"
          errorText={errors?.content}
          {...register('content')}
          className="w-[70%]"
          inputCustomClass="h-[100px]"
          fullWidth
        />
        <ButtonPrimary
          className="my-[10px] w-[30%]"
          testID="login-button-submit"
          isLoading={isLoading}
          type="submit"
        >
          Ajouter le commentaire
        </ButtonPrimary>
      </div>
      <div className="flex flex-col overflow-y-scroll max-h-[40vh]">
        {comments?.length === 0 || !comments
          ? "Il n'y a pas encore de commentaire ajoutés"
          : comments.map((t) => (
              <div
                className="border-b-[1px] border-b-black p-[10px] mb-8"
                key={t.id}
              >
                <p>
                  <span className="font-cabin-semi-bold">
                    {t.user
                      ? `${t.user.firstName.charAt(0)}. ${t.user.lastName}`
                      : 'Prium ONE'}
                  </span>{' '}
                  <span className="ml-[10px] text-color-medium-grey font-cabin-italic">
                    {dayjs(t.createdAt).format('L')}{' '}
                    {dayjs(t.createdAt).format('H:mm')}
                  </span>
                </p>
                <span className="whitespace-pre-line">{t.content}</span>
              </div>
            ))}
      </div>
    </form>
  );
};
